import React from "react";
import Loader from "../../../static/images/spinner.svg";

export const Spinner = ({ className }) => {
  return (
    <div className={`loader ${className ?? ""}`}>
      <img src={Loader} alt="loader" />
    </div>
  );
};
